import { type Common } from '../common.js';
import { type FlowTagRecord, type FlowTagSearchQuery } from '../models/flow/tag.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/tags';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FlowTagSearchQuery): Promise<FlowTagRecord[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
